import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { setSearchParam } from 'helpers/setSearchParam';

import { useApplicationState } from '@atlas/core';

import useInactivityTimer from 'src/terminal/hooks/useInactivityTimer';

const StillHereComponent = () => {
  const { pathname, search } = useLocation();
  const { replace } = useHistory();

  const inactive = useInactivityTimer();

  useEffect(() => {
    if (inactive) {
      replace(`${pathname}?${setSearchParam(search, 'cmd', 'stillHere')}`);
    }
  }, [inactive, pathname, replace, search]);

  return null;
};

const StillHereComponentWrapper = () => {
  const { authenticated } = useApplicationState();

  if (!authenticated) {
    return null;
  }

  return <StillHereComponent />;
};

export default StillHereComponentWrapper;
